<div class="item-list-component" [ngClass]="{ 'dx-rtl': rtlEnabled }" dir="{{rtlEnabled ? 'rtl' : 'ltr'}}">

  <div class="grid-buttons">
    <dx-button hint="{{ 'SHARED.ADD' | translate }}" icon="add" (onClick)="add()" [disabled]="!this.productId"></dx-button>
  </div>

  <br/>
  <dx-data-grid
                #calculationFieldsGrid
                id="printSection"
                [rtlEnabled]="rtlEnabled"
                [dataSource]="items"
                [showBorders]="true"
                [allowColumnReordering]="true"
                [hoverStateEnabled]="true"
                [columnAutoWidth]="true"
                [rowAlternationEnabled]="true"
                (onRowClick)="openEditClick($event)">
      <dxo-selection mode="single"></dxo-selection>
      <dxo-pager 
        [showPageSizeSelector]="true" 
        [allowedPageSizes]="[5, 10, 20, 30, 40, 50, 100, 200]" 
        [showNavigationButtons]="true" 
        [showInfo]="true" 
        infoText="{2} {{ 'SHARED.PAGINATION_TEXT_PLACEHOLDER' | translate | slice:2 }}">
    </dxo-pager>
    <dxi-column dataField="productProperty.name" caption="{{ 'SHARED.NAME' | translate }}" dataType="string">
    </dxi-column>
    <dxi-column [customizeText]="translateSelectBoxes" dataField="productProperty.propertyTypeId" caption="{{ 'SHARED.TYPE' | translate }}" dataType="string">
    </dxi-column>
    <dxi-column dataField="masterDataListField.name" caption="{{ 'PRODUCT.PROPERTY.MASTER_DATA_FIELD_NAME' | translate }}" dataType="string">
    </dxi-column>
    <dxi-column type="buttons" class="btns-column">
      <dxi-button hint="{{ 'SHARED.EDIT' | translate }}" icon="edit" [onClick]="editItem"></dxi-button>
      <dxi-button hint="{{ 'SHARED.DELETE' | translate }}" icon="trash" [onClick]="deleteItem"></dxi-button>
    </dxi-column>
</dx-data-grid>
</div>

<calculations-field-component (onAdded)="onProductPropertyAdded($event)" (onUpdated)="onProductPropertyUpdated($event)"></calculations-field-component>
